import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import { toast, Toaster } from 'react-hot-toast';
import MasterNavbar from '../components/layout/MasterNavbar';
import { GET_CUSTOMER_DATA_ENDPOINT } from '../utils/api';
import AmcDetailsCard from './AmcDetailsCard';
import ClientUsersCard from './ClientUsersCard';



function CustomerProfile() {
  const { id, token } = useParams();
  const navigate = useNavigate();

  const [customer, setCustomer] = useState(null);
  const [clientUsers, setClientUsers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!id || !token) {
      toast.error('Invalid access');
      navigate('/customers');
      return;
    }

    axios.post(GET_CUSTOMER_DATA_ENDPOINT, { id, customer_token: token })
      .then(res => {
        if (res.data.success && res.data.customer) {
          setCustomer(res.data.customer);
          setClientUsers(res.data.client_users || []);
        } else {
          toast.error(res.data.message || 'Failed to fetch customer');
        }
        setLoading(false);
      })
      .catch(err => {
        toast.error('Server error');
        setLoading(false);
      });
  }, [id, token, navigate]);

  if (loading) return <div className="text-center mt-5">⏳ Loading profile...</div>;
  if (!customer) return <div className="text-center mt-5 text-danger">❌ Customer not found</div>;

  return (
    <>
      <MasterNavbar />
      <Toaster position="top-center" />
      <div className="container mt-4">
        <h4>👤 Customer Profile</h4>

        {/* Basic Info Card */}
        <div className="card shadow p-4 mt-3">
          <h5 className="mb-3">📋 Basic Information</h5>
          <div className="row mb-2"><div className="col-md-4"><strong>Name:</strong></div><div className="col-md-8">{customer.name}</div></div>
          <div className="row mb-2"><div className="col-md-4"><strong>Distributor:</strong></div><div className="col-md-8">{customer.distributor_name}</div></div>
          <div className="row mb-2"><div className="col-md-4"><strong>Address:</strong></div><div className="col-md-8">{customer.address}</div></div>
          <div className="row mb-2"><div className="col-md-4"><strong>City:</strong></div><div className="col-md-8">{customer.city} - {customer.pincode}</div></div>
          <div className="row mb-2"><div className="col-md-4"><strong>State:</strong></div><div className="col-md-8">{customer.state}</div></div>
          <div className="row mb-2"><div className="col-md-4"><strong>GST No:</strong></div><div className="col-md-8">{customer.gst_no}</div></div>
          <div className="row mb-2"><div className="col-md-4"><strong>Remark:</strong></div><div className="col-md-8">{customer.remark}</div></div>
          <div className="row mb-2"><div className="col-md-4"><strong>Created By:</strong></div><div className="col-md-8">{customer.created_by_name} - {customer.created_at}</div></div>
          <div className="row mb-2"><div className="col-md-4"><strong>Updated By:</strong></div><div className="col-md-8">{customer.updated_by_name} - {customer.updated_at}</div></div>
        </div>

   {/* Client Users */}

        <ClientUsersCard
  clientUsers={clientUsers}
  customerId={id}
  customerToken={token}
/>

        {/* AMC Details */}
       <AmcDetailsCard
  id={id}
  token={token}
  amcData={{
    amc_start_date: customer.amc_start_date,
    amc_end_date: customer.amc_end_date,
    amc_remark: customer.amc_remark
  }}
/>

     


        <div className="text-end mt-4">
          <button className="btn btn-secondary" onClick={() => navigate('/customers')}>
            🔙 Back
          </button>
        </div>
      </div>
    </>
  );
}

export default CustomerProfile;
